import { Box, ButtonBase, SxProps } from '@mui/material';
import * as React from 'react';

import { ReactComponent as MenuIconCollapsed } from '../../../assets/images/icon-menu-collapsed.svg';
import { ReactComponent as MenuIcon } from '../../../assets/images/icon-menu.svg';

import styles from './NavToggle.module.scss';

interface IProps {
  expanded: boolean;
  onClick: () => void;
  style?: SxProps;
}

const NavToggle = ({ expanded, onClick, style }: IProps) => {
  return (
    <ButtonBase
      onClick={onClick}
      disableRipple
      sx={{
        width: 'fit-content',
        height: 'fit-content',
        alignSelf: 'flex-start',
        flexShrink: 0,
        borderRadius: 1,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...style,
      }}
      data-action="nav_toggle"
      className={styles.navToggle}
    >
      <Box sx={{ width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {expanded ? <MenuIconCollapsed className={styles.icon} /> : <MenuIcon className={styles.icon} />}
      </Box>
    </ButtonBase>
  );
};

export default NavToggle;
